import { timeZoneList } from "@src/helpers/constants";
import { Form, Select } from "antd";
import React from "react";

const { Option } = Select;

const TimeZone: React.FC = () => {
  return (
    <Form.Item name="timezoneOffset" label="Time Zone">
      <Select placeholder="">
        {timeZoneList?.map((timeZone: any) => (
          <Option key={timeZone.value} value={timeZone.value}>
            {timeZone.label}
          </Option>
        ))}

      </Select>
    </Form.Item>
  );
};

export default TimeZone;
